// extracted by mini-css-extract-plugin
export default {"section":"JA-z","inSectionButton":"KA-z","addressCard":"LA-z","disabled":"MA-z","cautionBox":"NA-z","failureBox":"OA-z","fade-out":"PA-z","successBox":"QA-z"};